<template>
  <div>
    <v-divider />
    <v-row class="d-flex justify-sm-end">
      <v-col cols="12" sm="6" lg="3">
        <v-btn
          color="primary"
          outlined
          :to="`/manage/forms/${moderatedOperation.object_type}/${moderatedOperation.form_name}/${moderatedOperation.id}`"
        >
          {{ $t("button.see.originalForm") }}
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <v-btn
          color="purple"
          outlined
          v-if="moderatedOperation.object_id"
          :to="`/manage/edit/stays/edit/${moderatedOperation.object_id}`"
        >
          {{ $t("button.see.editObject") }}
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col cols="6" sm="3" md="2" class="d-flex justify-center">
        <FinishFormSwitch :item="moderatedOperation" />
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="2">
        <ProcessingCommentDialog
          :moderated-operation="moderatedOperation"
        />
      </v-col>
    </v-row>
    <v-card class="pa-2" min-height="200">
      <v-overlay
        absolute
        :opacity="0.1"
        :value="isLoading"
      >
        <v-progress-circular indeterminate size="64" color="primary" />
      </v-overlay>
      <AssignSimpleRelationField
        v-if="!isLoading"
        @update-modOp-data="updateModOpData"
        :state="moderatedOperation.state"
        field="organization"
        label-key="form.organization_stay"
        :data-mod-op="moderatedOperation.data"
        :items-fromdb="organizations"
        items-fromdb-text="name"
      />
    </v-card>
    <v-divider />
    <ProcessFormActions
      :item="moderatedOperation"
      @item-processed="handleItemProcessed"
    />
  </div>
</template>

<script>
import axios from "axios";
import ProcessFormActions from "@/components/action_buttons/ProcessFormActions";
import AssignSimpleRelationField from "@/components/reusables/AssignSimpleRelationField";
import ProcessingCommentDialog from "@/components/reusables/ProcessingCommentDialog";
import FinishFormSwitch from "@/components/reusables/FinishFormSwitch";

export default {
  name: "ProcessStay",
  components: {
    FinishFormSwitch,
    ProcessingCommentDialog,
    ProcessFormActions,
    AssignSimpleRelationField
  },
  data: () => ({
    moderatedOperation: {},
    organizations: []
  }),
  computed: {
    isLoading() {
      return (
        this.moderatedOperation.data === undefined ||
        this.organizations.length === 0
      );
    }
  },
  created() {
    this.getOrganizations();
    this.getData();
  },
  methods: {
    handleItemProcessed(item) {
      this.moderatedOperation.state = item.state;
      this.moderatedOperation.object_id = item.object_id;
    },
    getData() {
      const path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/stay/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.moderatedOperation = response.data;
          this.normalizeModeratedOperation();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getOrganizations() {
      axios
        .get(this.$store.state.endpoint + "/organization")
        .then(response => {
          this.organizations = response.data
            .map(item => ({
              ...item,
              name: item.name || item.title || ""
            }))
            .sort((a, b) => a.name.localeCompare(b.name));
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateModOpData(data) {
      this.moderatedOperation.data = data;
      this.normalizeModeratedOperation();
    },
    normalizeModeratedOperation() {
      if (!this.moderatedOperation || !this.moderatedOperation.data) {
        return;
      }
      const { user, supervisor } = this.moderatedOperation.data;
      if (user && user.stay) {
        this.normalizeStay(user.stay);
      }
      if (supervisor && supervisor.stay) {
        this.normalizeStay(supervisor.stay);
      }
    },
    normalizeStay(stay) {
      if (!stay || !stay.organization) {
        return;
      }
      const org = stay.organization;
      if (typeof org === "number" || org === null) {
        return;
      }
      if (typeof org === "string") {
        stay.organization = {
          id: null,
          name: org
        };
        return;
      }
      if (typeof org === "object") {
        stay.organization = {
          id: org.id !== undefined ? org.id : null,
          name: org.name || org.title || ""
        };
      }
    }
  }
};
</script>
